import axios from 'axios';
axios.defaults.baseURL = 'https://orbita1535.ru:8444';

//  axios.defaults.baseURL = 'http://localhost:3000';
export default axios;